<template>
    <a v-if="isExternal"
       :href="realHref"
       :title="title"
       :target="target">
        <slot></slot>
    </a>
    <RouterLink v-else
                :to="realHref"
                :title="title">
        <slot></slot>
    </RouterLink>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'RouterLinkConditional',
    props: {
        href: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: '',
        },
        target: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const realHref = props.href.toLowerCase().startsWith('www') ? 'http://' + props.href : props.href;

        function isExternal(): boolean {
            if (props.target === '_blank') return true;
            try {
                return new URL(realHref).origin !== location.origin;
            } catch {
                return false;
            }
        }

        return {
            isExternal: isExternal(),
            realHref,
        };
    },
});
</script>
